__turbopack_context__.v({
  "root": "PlasmicTableTr-module__L7Phiq__root",
  "tableTd__fhlOq": "PlasmicTableTr-module__L7Phiq__tableTd__fhlOq",
  "tableTd__kN4Xg": "PlasmicTableTr-module__L7Phiq__tableTd__kN4Xg",
  "tableTd__si7In": "PlasmicTableTr-module__L7Phiq__tableTd__si7In",
  "tableTd__u6Ldr": "PlasmicTableTr-module__L7Phiq__tableTd__u6Ldr",
  "text__nQvc4": "PlasmicTableTr-module__L7Phiq__text__nQvc4",
  "text__nbnB": "PlasmicTableTr-module__L7Phiq__text__nbnB",
  "text__tsao3": "PlasmicTableTr-module__L7Phiq__text__tsao3",
  "text__zoAV": "PlasmicTableTr-module__L7Phiq__text__zoAV",
});
